import React, {
  HTMLProps,
} from 'react';
import clsx from 'clsx';
import BaseSkeleton, {
  SkeletonProps,
} from '@mui/material/Skeleton';

export type Props = Partial<HTMLProps<unknown>> & Pick<SkeletonProps, 'variant'>;

export default function Skeleton({
  className,
  variant = 'rectangular',
}: Props) {
  return (
    <BaseSkeleton
      animation="wave"
      variant={variant}
      className={clsx('w-1/2', className, {
        '!rounded-full': variant === 'circular',
        '!rounded-md': variant === 'rectangular',
      })}
    />
  );
}
